import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-texting-notification-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './texting-notification.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class TextingNotificationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<TextingNotificationTemplateData>;
}

export type TextingNotificationTemplateData = {
  title: string;
  p1: string;
  p2: string;
  contact_support_html: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const TextingNotificationTemplateMocks: TextingNotificationTemplateData[] = [
  {
    title: 'You’ve used 90% of your monthly text message limit',
    p1: 'Heads up! It looks like text messaging in ExampleCorp UK is going so well that you’re about to reach your monthly limit.',
    p2: 'Make sure that you have enough within the current limit or wait until the next billing period. Please note that both outgoing and incoming messages are deducted from your pool of messages.',
    contact_support_html:
      'Want more texts? <a href="mailto:support@recruitee.com">Contact our support</a> or wait until your limit renews on October 16.',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
